import { createApiSlice } from "../../components/common/commonSlice";
import {
  CRUD_CONTRACT_ACTIVITY,
  GET_CONTRACT_ACTIVITY_BY_CONTRACT_ID,
  CRUD_ACCOUNT_ACTIVITY,
  GET_ACCOUNT_ACTIVITY_BY_ACCOUNT_ID,
  CRUD_OPPORTUNITY_ACTIVITY,
  GET_OPPORTUNITY_ACTIVITY_BY_OPPORTUNITY_ID,
  CRUD_CONTACT_ACTIVITY,
  GET_CONTACT_ACTIVITY_BY_CONTACT_ID,
  CRUD_LEAD_ACTIVITY,
  GET_LEAD_ACTIVITY_BY_LEAD_ID,
  CRUD_CAMPAIGN_ACTIVITY,
  GET_CAMPAIGN_ACTIVITY_BY_CAMPAIGN_ID,
  CRUD_INQUIRY_ACTIVITY,
  GET_INQUIRY_ACTIVITY_BY_INQUIRY_ID,
  CRUD_PROSPECT_ACTIVITY,
  GET_PROSPECT_ACTIVITY_BY_PROSPECT_ID,
  CRUD_CUSTOMER_ACTIVITY,
  GET_CUSTOMER_ACTIVITY_BY_CUSTOMER_ID,
  CRUD_ORDER_ACTIVITY,
  GET_ORDER_ACTIVITY_BY_ORDER_ID,
} from "@routes";

// Define the API config array for Activity CRUD per entity
const apiConfig = [
  // Contract Activity
  {
    name: "addContractActivity",
    method: "post",
    url: CRUD_CONTRACT_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "getContractActivity",
    method: "get",
    url: GET_CONTRACT_ACTIVITY_BY_CONTRACT_ID,
    stateKey: "data",
  },
  {
    name: "updateContractActivity",
    method: "put",
    url: CRUD_CONTRACT_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "deleteContractActivity",
    method: "delete",
    url: CRUD_CONTRACT_ACTIVITY,
    stateKey: "message",
  },

  // Customer Account Activity
  {
    name: "addAccountActivity",
    method: "post",
    url: CRUD_ACCOUNT_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "getAccountActivity",
    method: "get",
    url: GET_ACCOUNT_ACTIVITY_BY_ACCOUNT_ID,
    stateKey: "data",
  },
  {
    name: "updateAccountActivity",
    method: "put",
    url: CRUD_ACCOUNT_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "deleteAccountActivity",
    method: "delete",
    url: CRUD_ACCOUNT_ACTIVITY,
    stateKey: "message",
  },

  // Opportunity Activity
  {
    name: "addOpportunityActivity",
    method: "post",
    url: CRUD_OPPORTUNITY_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "getOpportunityActivity",
    method: "get",
    url: GET_OPPORTUNITY_ACTIVITY_BY_OPPORTUNITY_ID,
    stateKey: "data",
  },
  {
    name: "updateOpportunityActivity",
    method: "put",
    url: CRUD_OPPORTUNITY_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "deleteOpportunityActivity",
    method: "delete",
    url: CRUD_OPPORTUNITY_ACTIVITY,
    stateKey: "message",
  },

  // Contact Activity
  {
    name: "addContactActivity",
    method: "post",
    url: CRUD_CONTACT_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "getContactActivity",
    method: "get",
    url: GET_CONTACT_ACTIVITY_BY_CONTACT_ID,
    stateKey: "data",
  },
  {
    name: "updateContactActivity",
    method: "put",
    url: CRUD_CONTACT_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "deleteContactActivity",
    method: "delete",
    url: CRUD_CONTACT_ACTIVITY,
    stateKey: "message",
  },

  // Lead Activity
  {
    name: "addLeadActivity",
    method: "post",
    url: CRUD_LEAD_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "getLeadActivity",
    method: "get",
    url: GET_LEAD_ACTIVITY_BY_LEAD_ID,
    stateKey: "data",
  },
  {
    name: "updateLeadActivity",
    method: "put",
    url: CRUD_LEAD_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "deleteLeadActivity",
    method: "delete",
    url: CRUD_LEAD_ACTIVITY,
    stateKey: "message",
  },

  // Campaign Activity
  {
    name: "addCampaignActivity",
    method: "post",
    url: CRUD_CAMPAIGN_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "getCampaignActivity",
    method: "get",
    url: GET_CAMPAIGN_ACTIVITY_BY_CAMPAIGN_ID,
    stateKey: "data",
  },
  {
    name: "updateCampaignActivity",
    method: "put",
    url: CRUD_CAMPAIGN_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "deleteCampaignActivity",
    method: "delete",
    url: CRUD_CAMPAIGN_ACTIVITY,
    stateKey: "message",
  },

  // Inquiry Activity
  {
    name: "addInquiryActivity",
    method: "post",
    url: CRUD_INQUIRY_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "getInquiryActivity",
    method: "get",
    url: GET_INQUIRY_ACTIVITY_BY_INQUIRY_ID,
    stateKey: "data",
  },
  {
    name: "updateInquiryActivity",
    method: "put",
    url: CRUD_INQUIRY_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "deleteInquiryActivity",
    method: "delete",
    url: CRUD_INQUIRY_ACTIVITY,
    stateKey: "message",
  },

  // Prospect Activity
  {
    name: "addProspectActivity",
    method: "post",
    url: CRUD_PROSPECT_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "getProspectActivity",
    method: "get",
    url: GET_PROSPECT_ACTIVITY_BY_PROSPECT_ID,
    stateKey: "data",
  },
  {
    name: "updateProspectActivity",
    method: "put",
    url: CRUD_PROSPECT_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "deleteProspectActivity",
    method: "delete",
    url: CRUD_PROSPECT_ACTIVITY,
    stateKey: "message",
  },

  // Customer Activity
  {
    name: "addCustomerActivity",
    method: "post",
    url: CRUD_CUSTOMER_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "getCustomerActivity",
    method: "get",
    url: GET_CUSTOMER_ACTIVITY_BY_CUSTOMER_ID,
    stateKey: "data",
  },
  {
    name: "updateCustomerActivity",
    method: "put",
    url: CRUD_CUSTOMER_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "deleteCustomerActivity",
    method: "delete",
    url: CRUD_CUSTOMER_ACTIVITY,
    stateKey: "message",
  },

  // Order Activity
  {
    name: "addOrderActivity",
    method: "post",
    url: CRUD_ORDER_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "getOrderActivity",
    method: "get",
    url: GET_ORDER_ACTIVITY_BY_ORDER_ID,
    stateKey: "data",
  },
  {
    name: "updateOrderActivity",
    method: "put",
    url: CRUD_ORDER_ACTIVITY,
    stateKey: "message",
  },
  {
    name: "deleteOrderActivity",
    method: "delete",
    url: CRUD_ORDER_ACTIVITY,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
    loading: false,
    selectedData: null,
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
};

const { slice, thunks, actions } = createApiSlice(
  "activity",
  apiConfig,
  customReducers,
);

const activitySlice = slice;

export default activitySlice.reducer;

// Export individual entity thunks
export const {
  // Contract
  addContractActivity,
  getContractActivity,
  updateContractActivity,
  deleteContractActivity,

  // Account
  addAccountActivity,
  getAccountActivity,
  updateAccountActivity,
  deleteAccountActivity,

  // Opportunity
  addOpportunityActivity,
  getOpportunityActivity,
  updateOpportunityActivity,
  deleteOpportunityActivity,

  // Contact
  addContactActivity,
  getContactActivity,
  updateContactActivity,
  deleteContactActivity,

  // Lead
  addLeadActivity,
  getLeadActivity,
  updateLeadActivity,
  deleteLeadActivity,

  // Campaign
  addCampaignActivity,
  getCampaignActivity,
  updateCampaignActivity,
  deleteCampaignActivity,

  // Inquiry
  addInquiryActivity,
  getInquiryActivity,
  updateInquiryActivity,
  deleteInquiryActivity,

  // Prospect
  addProspectActivity,
  getProspectActivity,
  updateProspectActivity,
  deleteProspectActivity,

  // Customer
  addCustomerActivity,
  getCustomerActivity,
  updateCustomerActivity,
  deleteCustomerActivity,

  // Order
  addOrderActivity,
  getOrderActivity,
  updateOrderActivity,
  deleteOrderActivity,
} = thunks;

export const { rowSelect } = actions;
